import { ZOOM_IN_MUT, ZOOM_OUT_MUT, RESET_ZOOM_MUT } from "./constants.js";
import { initialState } from "./index";

export default {
  [ZOOM_IN_MUT](state) {
    state.zoom += 2;
  },
  [ZOOM_OUT_MUT](state) {
    if (state.zoom > 2) {
      state.zoom -= 2;
    }
  },
  [RESET_ZOOM_MUT](state) {
    Object.assign(state, initialState());
  }
};
